import { GetProfileDto } from '../../../dto/getprofile/getprofiledto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface GetProfileDetailsRequest extends APIRequest
{
    getGetProfileDetailsRequest(): GetProfileDto;
}

export class GetProfileDetailsRequestImpl extends APIRequestDtoImpl implements GetProfileDetailsRequest
{
    constructor(private getProfileDetailsData: GetProfileDto)
    {
        super();
    }

    getGetProfileDetailsRequest(): GetProfileDto
    {
        return this.getProfileDetailsData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/getprofiledetails/getprofiledetailsrequest.tsx